import { render, staticRenderFns } from "./LicenseContent.vue?vue&type=template&id=17a829c9&scoped=true"
import script from "./LicenseContent.vue?vue&type=script&lang=js"
export * from "./LicenseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a829c9",
  null
  
)

export default component.exports